import { createContext, useContext, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, FAIL_CLOSED_FLAGS, type FeatureFlags } from './api';

const FeatureFlagsContext = createContext<FeatureFlags>(FAIL_CLOSED_FLAGS);

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  // Session-cached: fetched once at app load, never refetches. Reload the
  // page to pick up flag changes. Fail-CLOSED on error.
  const query = useQuery({
    queryKey: ['feature-flags'],
    queryFn: () => api.getFeatureFlags(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });

  return (
    <FeatureFlagsContext.Provider value={query.data ?? FAIL_CLOSED_FLAGS}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagsContext);
}
